import { Scalar } from '@flatfile/adapter/build/main/interfaces';

export const normalizeColumns = (columns: [Scalar, number][]): Scalar[] => {
	if (!columns) {
		return [];
	}
	return columns.map(column => column[0]);
};
